export enum ECatalogFilter {
  STUDIED_LANGUAGE = "studied-language",
  LANGUAGE = "language",
  DIFFICULTY = "difficulty",
  GRADE = "grade",
  SUBJECT = "subject",
  CONCEPT = "concept",
  TYPE = "type",
  REGION = "region",
  SOURCE = "source",
}
